import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class ChallengeService {
    static getChallenges(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`challenges?filter=${qs}`, pageNumber));
    }
    static fetchChallenge(oid) {
        return lastValueFrom(BaseService.get(`challenges/${oid}`));
    }
    static saveChallenge(dto) {
        return lastValueFrom(BaseService.save(`challenges`, dto));
    }
    static deleteChallenge(oid) {
        return lastValueFrom(BaseService.delete(`challenges/${oid}`));
    }
    static searchChallengeCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`challenges-search-dropdown/${selfId}?search=${qs}`));
    }
    static getAllChallengesWithUserStats(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`challenges-user-stats?filter=${qs}`));
    }
    static getChallengeSampleFiles(challengeId) {
        return lastValueFrom(BaseService.get(`challenges-sample-files/${challengeId}`));
    }
    // ----------------------------------------------------------------------
    // Stats
    // ----------------------------------------------------------------------
    static fetchChallengeStats(oid) {
        //return lastValueFrom(BaseService.get<IDossierStatsDTO>(`challenges-stats/${oid}`));
        return null;
    }
}
